// url的链接
import DOMAIN from './domain.js'
export const urls = {
  // mock数据获取例子
  getClassroomList: 't/mobile/token/request',
  // 获取用户信息
  getUser: 't/mobile/user/get',
  // 获取tooken
  getToken: 't/mobile/token/request',

  // 获取用户下面的地区的
  areaList: 't/mobile/area/list',

  // 添加收藏
  save: 'emm/favorite/save',
  // 删除收藏
  delete: 'emm/favorite/delete',
  //判断是否藏在该收藏
  isExisted: 'emm/favorite/isExisted',

  // 新增客户的拆线图数据
  getLineList: 't/mobile/token/getLineList',

  // 指标的数据接口
  data184: 't/mobile/data/184',

  // 99套餐的下钻的数据
  getDrillDown: 't/mobile/data/178',
  // 99套餐页面和表格的数据
  rank: 't/mobile/indicator/rank', // 参数传type type只有三个 (“99”， “kd”, "kh")

  // 新增用户的数据
  //  收入/账单收入 下的 '当日账单收入' 指标的数据接口
  dayBill: 't/mobile/data/191',
  // 收入/账单收入 下的 当月期末账单收入' 指标的数据接口
  monthBill: 't/mobile/data/196',
  // 渠道搜索接口
  getDeparts: 't/mobile/data/361',
  // 搜素渠道结果获取数据接口
  getDataByDeparts: 't/mobile/indicator/getDepartList',
  // 具体渠道三个类型的数据
  getDepartTypeList: 't/mobile/indicator/getDepartTypeList',
  // App使用情况：（只做到区县级）
  appUsage: 't/mobile/data/403',
  data404: 'dev/data/404',
  // data404: 'mobile/data/404',
}

for (var i in urls) {
  urls[i] = DOMAIN + urls[i]
}
export default urls



// WEBPACK FOOTER //
// ./src/libs/urls.js